import React, { useEffect, useState, useRef } from 'react';
import { CountDownTimerProps } from './OffersMBEHero.types';
import { calculateTimeLeft, checkCampaignStatus } from '../../utils/OfferUtils';
import { constants } from '../../constants/CommonConstants';
import { StyledOffersMBEHero } from './OffersMBEHero.styles';

export const CountDownTimer: React.FC<CountDownTimerProps> = props => {
  const { startDate, endDate, isAuthorMode, model, onCountdownComplete } = props;
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(startDate, isAuthorMode));
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isAuthorMode) return;

    const isZero = (time: typeof timeLeft) =>
      time.days === 0 && time.hours === 0 && time.minutes === 0 && time.seconds === 0;

    const handleComplete = () => {
      if (checkCampaignStatus(startDate, endDate) === constants.CAMPAIGN_ACTIVE) {
        onCountdownComplete?.();
      }
    };

    const updateTime = () => {
      const newTimeLeft = calculateTimeLeft(startDate, isAuthorMode);
      setTimeLeft(newTimeLeft);

      if (isZero(newTimeLeft)) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        handleComplete();
      }
    };

    updateTime();
    if (!isZero(calculateTimeLeft(startDate, isAuthorMode))) {
      intervalRef.current = setInterval(updateTime, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [startDate, endDate, isAuthorMode, onCountdownComplete]);

  const timeLabels = [model.daysLabel, model.hoursLabel, model.minutesLabel, model.secondsLabel];
  const timeEntries = Object.entries(timeLeft);

  return (
    <StyledOffersMBEHero>
      <div className="countdownWrapper">
        {timeEntries.map(([key, value], index) => (
          <React.Fragment key={key}>
            {index > 0 && <div className="separator" />}
            <div className="countdownUnit">
              <div className="countdownTile">
                <span className="countdownNumber">
                  {value !== undefined ? value.toString().padStart(2, '0') : '00'}
                </span>
              </div>
              <div className="countdownLabelsWrapper">
                <span className="countdownLabel">{timeLabels[index]}</span>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </StyledOffersMBEHero>
  );
};

export default CountDownTimer;
